import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: '#F9F6F0', minHeight: '100vh', paddingTop: '100px', paddingBottom: '60px' }}>
      <Navbar />

      <div className="container" style={{ maxWidth: '800px', backgroundColor: '#fff', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <h1 style={{ fontSize: '36px', color: 'var(--color-text)', marginBottom: '24px', textAlign: 'center' }}>
          Informativa sulla Privacy e sui Cookie
        </h1>

        <div style={{ color: 'var(--color-text-light)', lineHeight: '1.8', fontSize: '16px' }}>
          <p>Ultimo aggiornamento: Aprile 2026</p>

          <h2 style={{ fontSize: '24px', color: 'var(--color-text)', marginTop: '32px', marginBottom: '16px' }}>1. Introduzione</h2>
          <p>
            Benvenuto sul sito web di Glad Dogs. La tua privacy è importante per noi. Questa Informativa sulla Privacy spiega come raccogliamo, utilizziamo, divulghiamo e proteggiamo le tue informazioni quando visiti il nostro sito web.
          </p>

          <h2 style={{ fontSize: '24px', color: 'var(--color-text)', marginTop: '32px', marginBottom: '16px' }}>2. Informazioni che Raccogliamo</h2>
          <p>
            Possiamo raccogliere informazioni personali che ci fornisci volontariamente, come:
          </p>
          <ul style={{ marginLeft: '24px', marginBottom: '16px', listStyleType: 'disc' }}>
            <li>Nome e cognome</li>
            <li>Indirizzo email</li>
            <li>Numero di telefono</li>
            <li>Informazioni fornite nei moduli di contatto o di richiesta adozione</li>
          </ul>

          <h2 style={{ fontSize: '24px', color: 'var(--color-text)', marginTop: '32px', marginBottom: '16px' }}>3. Come Utilizziamo le Tue Informazioni</h2>
          <p>
            Utilizziamo le informazioni che raccogliamo per:
          </p>
          <ul style={{ marginLeft: '24px', marginBottom: '16px', listStyleType: 'disc' }}>
            <li>Gestire le richieste di adozione</li>
            <li>Rispondere alle tue domande e richieste</li>
            <li>Inviarti comunicazioni relative alle nostre attività (se hai acconsentito)</li>
            <li>Migliorare il nostro sito web e i nostri servizi</li>
          </ul>

          <h2 style={{ fontSize: '24px', color: 'var(--color-text)', marginTop: '32px', marginBottom: '16px' }}>4. Cookie</h2>
          <p>
            Il nostro sito utilizza i "cookie" per migliorare l'esperienza dell'utente. I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo. Utilizziamo i cookie per:
          </p>
          <ul style={{ marginLeft: '24px', marginBottom: '16px', listStyleType: 'disc' }}>
            <li>Ricordare le tue preferenze (es. consenso ai cookie)</li>
            <li>Analizzare il traffico del sito in modo aggregato e anonimo</li>
          </ul>
          <p>
            Puoi scegliere di disabilitare i cookie attraverso le impostazioni del tuo browser, ma questo potrebbe limitare alcune funzionalità del sito.
          </p>

          <h2 style={{ fontSize: '24px', color: 'var(--color-text)', marginTop: '32px', marginBottom: '16px' }}>5. Condivisione delle Informazioni</h2>
          <p>
            Non vendiamo, scambiamo o affittiamo le tue informazioni personali a terzi. Possiamo condividere informazioni generiche aggregate, non collegate ad alcuna informazione di identificazione personale, con i nostri partner di fiducia per le finalità sopra descritte.
          </p>

          <h2 style={{ fontSize: '24px', color: 'var(--color-text)', marginTop: '32px', marginBottom: '16px' }}>6. Sicurezza</h2>
          <p>
            Adottiamo misure di sicurezza adeguate per proteggere le tue informazioni personali da accessi non autorizzati, alterazioni, divulgazioni o distruzioni.
          </p>

          <h2 style={{ fontSize: '24px', color: 'var(--color-text)', marginTop: '32px', marginBottom: '16px' }}>7. I Tuoi Diritti</h2>
          <p>
            Hai il diritto di accedere, correggere o cancellare le tue informazioni personali in nostro possesso. Per esercitare questi diritti, contattaci utilizzando i dettagli forniti di seguito.
          </p>

          <h2 style={{ fontSize: '24px', color: 'var(--color-text)', marginTop: '32px', marginBottom: '16px' }}>8. Contatti</h2>
          <p>
            Se hai domande su questa Informativa sulla Privacy, contattaci a: <br />
            <strong>Email:</strong> gladdogs.licata@gmail.com<br />
            <strong>Telefono:</strong> +39 3282268731
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
